function contactsMapInit() {
    var coords = document.querySelector('.js-contacts-coords').dataset.coords;
    if (coords) {
        var contactsMap;
        var contactsMapCoords = coords.split(', ');
        contactsMap = new ymaps.Map("contactsMap", {
            center: contactsMapCoords,
            zoom: 16,
            controls: ['zoomControl'],
        });

        contactsMap.behaviors.disable('scrollZoom');

        var point = new ymaps.GeoObjectCollection({},
            {
                iconLayout: 'default#image',
                iconImageHref: document.querySelector('.js-contacts-coords').dataset.pinSrc,
                iconImageSize: [42, 42],
                iconImageOffset: [-21, -42],
            }
        );
        point.add(new ymaps.Placemark(contactsMapCoords));
        contactsMap.geoObjects.add(point);
    }
}